import React from "react";
import NavMenu from "./Menu";
import ParticlesBg from "particles-bg";
import { Container } from "@mui/material";
import { Link } from 'react-router-dom';

const  About = () => {

    return (
      <>
        <ParticlesBg num={10} type="circle" bg={true} />

        <NavMenu />
        <Container className="container" maxWidth="sm"	>
          <p>
            <h1>FAQ</h1>
            <h4>Knight's Kennel</h4> <p> </p>
            <hr className="mt-4 mb-4" />
            <h4>How much are your puppies?</h4>
            We charge $1300 - $2000 depending on which female we breed. Our male
            is an amazing miniature schnauzer with fantastic bloodlines. Our male Chihuahua is also 
            a beautiful purebred with Russian Champion Bloodlines. Our female Martha has retired from
            breeding but we hope to get Onyx pregnant with her first litter soon. (Dated 12 August 21)
            Click here to <Link to={'/email' }><span className="dog">contact us.</span></Link>{" "}
          </p>
          <p>
            <small>
              We do not deliver or ship unfortunately. We prefer to meet in
              person. We believe it's an important beginning in a dog's life to
              make sure there is a good fit between owner and puppy. Some
              schnauzers are temperamental, many are vocal, some are shy, some
              are outgoing and many are just little sweethearts.
            </small>
          </p>
          <hr className="mt-4 mb-4" />

          <h4>Where are you located? </h4>
          <p>
            {" "}
            We are located in Rhode Island, near Newport, on the Island of
            Aquidneck.
          </p>
          <p>
            <small>
              We are 35 minutes from Providence RI and 50 minutes from Boston
              MA. Our address is: 41 Hilltop Ave, Middletown, RI 02842. 
              Our phone number is: 401-418 4818{" "}
            </small>
            <br></br>
          </p>
          <hr className="mt-4 mb-4" />

          <h4>Are your puppies AKC registered? </h4>
          <p>
            {" "}
            Yes. Our puppies come with limited AKC registrations for pets and
            full AKC registrations for show quality dogs. If we have a mix available we do 
            not offer papers. {" "}
          </p>
          <p>
            <small>
              Our all-black male is sired by two grandchampions. His father is a Repetition Silver Grand Champion 
              male and his mother is a Bronze Grand Champion. They are absolutely stunning and well-behaved dogs.
              {" "}
            </small>{" "}
          </p>
        </Container>
      </>
    );
  }

export default About;
